export function rangeArray(start, end) {
  const newArr = [];
  for (let i = parseInt(start); i <= parseInt(end); i++) {
    newArr.push(i);
  }
  return newArr;
}